import PropTypes from 'prop-types';
import cx from 'classnames';
import classNames from './Card.module.scss';

export default function Card({ children, className }) {
  const cn = cx(classNames.card, className);
  return <div className={cn}>{children}</div>;
}

export function CardHeader({ children, className }) {
  const cn = cx(classNames.header, className);
  return <div className={cn}>{children}</div>;
}

export function CardContent({ children, className }) {
  const cn = cx(classNames.content, className);
  return <div className={cn}>{children}</div>;
}

export function CardFooter({ children, className }) {
  const cn = cx(classNames.footer, className);
  return <div className={cn}>{children}</div>;
}

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

CardHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

CardFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};
